import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CookieBanner from './components/cookieBanner/CookieBanner';
import { useScrollToHash } from './hooks/useScrollToHash';
import ContactUs from './pages/contactUs/ContactUs';
import Home from './pages/home/Home';
import LearnMore from './pages/learnMore/LearnMore';
import LearnMoreLanding from './pages/learnMore/LearnMoreLanding';
import ClubMobileApp from './pages/learnMore/clubMobileApp/ClubMobileApp';
import ContentManagement from './pages/learnMore/contentManagement/ContentManagement';
import CustomisedClubWebsite from './pages/learnMore/customisedClubWebsite/CustomisedClubWebsite';
import HandsOnSupport from './pages/learnMore/handsOnSupport/HandsOnSupport';
import MembershipManagement from './pages/learnMore/membershipManagement/MembershipManagement';
import SeamlessPaymentsRefunds from './pages/learnMore/seamlessPaymentsRefunds/SeamlessPaymentsRefunds';

export default function App(): React.JSX.Element {
  useScrollToHash();

  return (
    <>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/learn-more">
        <Route index element={<LearnMoreLanding />} />
        <Route element={<LearnMore />}>
          <Route path="customised-club-website" element={<CustomisedClubWebsite />} />
          <Route path="content-management" element={<ContentManagement />} />
          <Route path="club-mobile-app" element={<ClubMobileApp />} />
          <Route path="membership-management" element={<MembershipManagement />} />
          <Route path="seamless-payments-refunds" element={<SeamlessPaymentsRefunds />} />
          <Route path="hands-on-support" element={<HandsOnSupport />} />
        </Route>
      </Route>
    </Routes>
    <CookieBanner />
    </>
  );
}
